import React, { useCallback } from "react";
import VStack from "../../ui_atoms/VStack";
import ScreenCard from "../ScreenCard";
import { useI18n } from "../../hooks/i18n-hooks";
import AddressField from "../../components/address/AddressField";
import { Address, ClientProfile } from "../../__generated__/graphql";
import { useCurrentProfile } from "../../hooks/use-current-profile";
import TextField from "../../components/TextField";
import MarkdownView from "../../components/MarkdownView";
import { useIntercom } from "../../hooks/intercom";

const ClientEditorScreen = () => {
    const i18n = useI18n();
    const currentProfile = useCurrentProfile<ClientProfile>();
    const { presentMessageComposer } = useIntercom();

    const onValidate = useCallback(async () => {
        await presentMessageComposer();
    }, [presentMessageComposer]);

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.t("profile.contact_support"),
                    onPress: onValidate,
                    mode: "secondary",
                },
            ]}
        >
            <VStack v={1} gap={1} alignment="stretch" h="2/3">
                <TextField
                    label={i18n.t("screens.auth.check_client_info.company_name_label")}
                    value={currentProfile.client.name as string}
                    disabled
                />
                <AddressField
                    value={currentProfile.client.address as Address}
                    label={i18n.t("client.address")}
                    disabled
                />
                <MarkdownView markdown={i18n.t("profile.contact_us_for_change")} />
            </VStack>
        </ScreenCard>
    );
};

export default ClientEditorScreen;
